import type { Ref } from "vue";
import { ref, onMounted, onUnmounted } from "vue";

export function useScrollVisibility(
	targetBlockRef: Ref<HTMLElement | null>,
	offset: number = 0
) {
	const isVisible = ref(false);

	const checkScrollPosition = () => {
		const targetBlock = targetBlockRef.value;

		if (!targetBlock) return;

		const blockRect = targetBlock.getBoundingClientRect();
		const windowHeight = window.innerHeight;

		isVisible.value =
			blockRect.top < -offset && blockRect.bottom < windowHeight;
	};

	const handleScroll = () => {
		requestAnimationFrame(checkScrollPosition);
	};

	onMounted(() => {
		if (!targetBlockRef.value) {
			return;
		}

		window.addEventListener("scroll", handleScroll);
		checkScrollPosition();
	});

	onUnmounted(() => {
		window.removeEventListener("scroll", handleScroll);
	});

	return {
		isVisible
	};
}
